<template>
	<div class="w1">
	<div class="Search_wrapper">
		<!-- Search_wrapper -->
		<div class="Search_Container">
			<div class="Search1">
				<!-- Search1 -->
				<div class="Sinput_out">
					<i v-show="keyword" class="cei-icon icon-search-clear" @click="clearword"></i>
					<input type="text" v-model="keyword" @focus="showsug" @keyup="showsug" @blur="hidesug"
						@keypress.enter="searchJump" class="Sinput" value="" placeholder="输入搜索内容" tabindex="-1" style="width:100%">
				</div>
				<button type="button" @click="searchJump" class="Sbtn">搜索</button>
			
				<div class="search_dropdown" v-show="showsugflag&&sugwordsList.length">
					<!-- search_dropdown -->
					<ul class="hotkeywords">
						<li v-for="(item,index) in sugwordsList" @mousedown="selhistory(item)">
							<btn v-html="item.replace(cachekeyword,'<span style=\'font-weight:bold;\'>'+cachekeyword+'</span>')"></btn>
						</li>
					</ul>
				</div><!-- /search_dropdown -->
			
				<div class="search_dropdown" v-show="showhistroyflag">
					<!-- search_dropdown -->
					<div class="search-history">
						<!-- search-history -->
						<ul class="title5">
							<li class="L">检索历史</li>
							<li class="R">
								<btn @mousedown.prevent="removehistoryall" class="clearall">清空全部</btn>
							</li>
						</ul>
						<ul class="history-words">
							<li v-for="(item,index) in keyhistory" class="">
								<btn @mousedown="selhistory(item)">{{item}}</btn><i @mousedown.prevent="removehistory(item)"
									class="cei-icon icon-history-clear"></i>
							</li>
						</ul>
						<ul class="title5">
							<li class="L">检索热词</li>
							<li class="R"></li>
						</ul>
						<ul class="hot-words">
							<li v-for="(item,index) in hotwords" class="" class="">
								<btn @mousedown="selhistory(item)">{{item}}</btn>
							</li>
						</ul>
			
			
					</div><!-- /search-history -->
				</div><!-- /search_dropdown -->
			</div><!-- /Search1 -->
			<div class="Search_ai" v-if="userinfo&&(userinfo.usertype=='99'||isShowAISearch)">
				<button type="button" class="Search_ai_btn" @click="aisearchJump" ><span>AI</span>搜索</button>
			</div>
		</div>
		


		<div class="m_b1"></div>

		<div class="group4" v-if="(searchword&&totalResultCount)||loadingMask" v-loading="loadingMask">
			<!-- group4 -->
			<div class="group4_M" style="background: none;">
				<!-- group4_M -->

				<el-row>
					<el-col :span="24">
						<el-menu :default-active="searchColum" mode="horizontal" text-color="#424656"
							active-text-color="#bd1a2d" @select="searchColumChange">
							<el-menu-item index="">综合</el-menu-item>
							<el-menu-item v-for="(item,index) in resultColumnList" v-bind:index="item.columnID">
								{{item.columnName}}({{item.AtlCount}})</el-menu-item>
						</el-menu>
					</el-col>
				</el-row>
				<el-row>
					<el-col :span="24">
						
						<div class="Tabnav_box"><!-- Tabnav_box -->
								<div class="Tabnav_box_L">
								</div>
								<div class="Tabnav_box_R2">

									<div id="datePanelDiv" class="Tabnav_out" name="Tabnav_out" @click="showDatePanel()" ><!-- Tabnav_out -->
										<div class="Tabnav_screen2" name="Tabnav_screen">{{dateTypeText}}</div>
										<!-- <el-collapse-transition> -->
										<ul class="Tabnav1"  name="Tabnav"  style="right: 0;" v-show="datePanelVisible">
											<li @click.stop="dateClick(0,'时间不限')" :class="dateType==0?'on':''">时间不限</li>
											<li @click.stop="dateClick(1,'一周内')" :class="dateType==1?'on':''">一周内</li>
											<li @click.stop="dateClick(2,'一月内')" :class="dateType==2?'on':''">一月内</li>
											<li @click.stop="dateClick(3,'一年内')" :class="dateType==3?'on':''">一年内</li>
											<li @click.stop="dateClick(4,'自定义')" :class="dateType==4?'on':''">
												<div>自定义</div>
												<div class="" v-on:click.stop >
													<el-date-picker
														v-model="dateStr"
														type="daterange"
														value-format="yyyy-MM-dd"
														range-separator="至"
														start-placeholder="开始日期"
														end-placeholder="结束日期"
														@change="dateClick(4,'自定义')">
													</el-date-picker>
												</div>
											</li>
											
										</ul>
										<!-- </el-collapse-transition> -->
									</div><!-- /Tabnav_out -->
						
								</div>
						</div><!-- /Tabnav_box -->	

						<div class="thematic_list  ">
							<!-- thematic_list -->
							<section v-for="(result,index) in resultDataList" :key="result.id" style="margin-bottom: 48px;">
								<dl>
									<dd>
										<a target="_blank" style="font-weight: bold;" @click="jumppush('/detail/'+result.id+'?key='+searchword+'&s=s')" class="T-tit"
											v-html="result.title.replace(/color:Red/g,'color:#bd1a2d;font-weight:bold;')"></a>
									</dd>
									<!-- <R v-if="result.exattribute8">
										<btn name="D_zcjd" @click="showZCJD(result.id)">
											<icon class="icon-news"></icon>政策解读
										</btn>
									</R> -->
									<!-- <R style="color: #a1a4ab;">{{result.publishtime?result.publishtime.substring(0,10):''}}</R> -->
								</dl>
								<dl v-if="result.content&&result.content.indexOf('.pdf</attachment>')>-1" style="margin: 24px 0px 16px 0px">
									<dd  style="white-space: normal; display: -webkit-box; overflow: hidden; text-overflow: ellipsis; -webkit-box-orient: vertical; -webkit-line-clamp: 3;">
										<a
											target="_blank" style="color: #a1a4ab;" @click="jumppush('/detail/'+resultHitList[index].id+'?key='+searchword+'&s=s')" 
											v-html="result.summary">
										</a>
									</dd>
								</dl>
								<dl v-else-if="resultHitList[index]&&resultHitList[index].hitPara&&resultHitList[index].hitPara.length>0" style="margin: 24px 0px 16px 0px">
									<dd  style="white-space: normal; display: -webkit-box; overflow: hidden; text-overflow: ellipsis; -webkit-box-orient: vertical; -webkit-line-clamp: 3;">
										<a
											target="_blank" style="color: #a1a4ab;" @click="jumppush('/detail/'+resultHitList[index].id+'?key='+searchword+'&s=s')" 
											v-html="resultHitList[index].hitPara[0].text.replace(/color:Red/g,'color:#bd1a2d;')">
										</a>
									</dd>
								</dl>
								<dl v-else style="margin-bottom: 16px;">
									<dd >
										
									</dd>
									<!-- <ul v-if="resultHitList[index]&&resultHitList[index].hitPara&&resultHitList[index].hitPara.length>0" class="list4">
										<li class="li2" v-for="(para,paraindex) in resultHitList[index].hitPara"
											v-if="paraindex<5">
											<router-link
												target="_blank" :to="{ name: 'detail', params: { id: resultHitList[index].id }, query:{ key: searchword }}"
												v-html="'...'+para.text+'...'">
											</router-link>
										</li>
										<div>{{result.publishtime?result.publishtime.substring(0,10):''}}</div>
									</ul>
									<ul v-else class="list4" style="margin-bottom: 40px;">
										
									</ul> -->
								</dl>
								<dl>
									<dd style="line-height: 1;">
										<R style="color: #a1a4ab;margin-left: 0px;top:0px;">{{result.publishtime?result.publishtime.substring(0,10):''}}</R>
									</dd>
									<R v-if="result.exattribute8">
										<btn name="D_zcjd" @click="showZCJD(result.id)">
											<icon class="icon-news"></icon>政策解读
										</btn>
									</R>
								</dl>
							</section>
						</div><!-- /thematic_list -->

						<!-- <el-row v-else>
									<el-empty description="暂无数据"></el-empty>
								</el-row> -->




						<div class="m_b1"></div>
						
						<div v-if="pageNum==1" class="footerBar">
							<div class="splitline1"></div>
						  <!-- <span></span> -->
						  <a @click="showfankui">
								<span>不是期望的结果？提交反馈</span>
								<div style="display: inline-block;">
									<a class="fankuibutton"></a>
								</div>
							</a>
							<div class="splitline1"></div>
						</div>

						<el-row class="pagediv">
							<el-pagination @size-change="changePageSize" @current-change="changeSearchPage"
								:current-page="pageNum" :page-sizes="[10, 20, 30]" :page-size="pageSize"
								layout="total, sizes, prev, pager, next, jumper" :total="totalResultCount">
							</el-pagination>
						</el-row>



					</el-col>
				</el-row>

			</div><!-- /group4_M -->
			<div v-if="relateDataList.length" class="group4_R">
				<!-- group4_R -->

				<div class="rel_search">
					<tit>相关搜索</tit>
					<ul class="rel_search_list">
						<li v-for="(item,index) in relateDataList"><a @click="selhistory(item)" style="cursor: pointer;">{{item}}</a></li>

					</ul>

				</div>


			</div><!-- /group4_R -->
		</div><!-- /group4 -->

		<div v-else-if="!searchword" class="search_none">
			<img src="/images/search_none_img2.png" width="293" height="238" alt="" />
			<h5>暂无数据，输入关键字进行搜索吧~</h5>
		</div>

		<div v-else class="search_none">
			<img src="/images/search_none_img1.png" width="293" height="238" alt="" />
			<h5>抱歉~暂无数据，可尝试更换关键字~</h5>
		</div>

		<div class="m_b1"></div>


<div class="zcjdpanel _popRight"  id="policy_pop" style="display: block;" v-show="zcjdPanelVisible"><!-- policy_interpret -->
	<div class="pop_right"><!-- pop_right -->
		<div class="pop_right_header"><btn class="pop_right_close" @click="hideZCJD" name="pop-close"></btn></div>
		<div class="pop_right_main" v-loading="loadingMaskZcjd"><!-- main -->
			
			<ul class="policy_list">
				<li v-for="(item,index) in zcjdresultDataList">
					<div class="tit">
						<a target="_blank" @click="jumppush('/detail/'+item.id+'?s=s')" style="font-weight: bold;">
							{{item.articletitle}}</a>
						</div>
					<div class="txt">{{item.summary.length>80?item.summary.substring(0,80)+'...':item.summary}}</div>
					<div class="date">{{item.publishtime?item.publishtime.substring(0,10):''}}</div>
				</li>
			</ul>
			
		</div><!-- /main -->
		<div style="margin-bottom: 32px;">
				<el-row class="pagediv">
					<el-pagination @current-change="zcjdchangeSearchPage" :current-page="zcjdpageNum" :page-size="10"
						layout="total, prev, pager, next" :total="zcjdtotalResultCount">
					</el-pagination>
				</el-row>
		</div>
		<div class="pop_right_footer">
				
		</div>
	</div><!-- /pop_right -->
	<div class="pop_bg" style="display: block;" @click="hideZCJD"></div>
</div><!-- /policy_interpret -->



		<!-- <el-dialog title="政策解读" :visible.sync="zcjdPanelVisible" width="40%">
			<el-row v-for="(item,index) in zcjdresultDataList" style="padding: 10px;">
				<el-row>
					<el-col :span="20">
						<router-link :to="{ name: 'detail', params: { id: item.id }}" style="font-weight: bold;">
							{{item.articletitle}}</router-link>
					</el-col>
					<el-col :span="4">{{item.publishtime.substring(0,10)}}</el-col>
				</el-row>
				<el-row>
					<el-col :span="24">
						<p>{{item.summary.length>80?item.summary.substring(0,80)+'...':item.summary}}</p>
					</el-col>
				</el-row>
			</el-row>
			<el-row class="pagediv">
				<el-pagination @current-change="zcjdchangeSearchPage" :current-page="zcjdpageNum" :page-size="10"
					layout="total, prev, pager, next" :total="zcjdtotalResultCount">
				</el-pagination>
			</el-row>
		</el-dialog> -->


	</div><!-- /Search_wrapper -->
</div>
</template>

<script>
	export default {
		data() {
			return {
				userinfo:'',
				hasPower:true,
				loadingMask: false,
				loadingMaskZcjd: false,
				searchType: '1',
				searchColum: '',
				searchword: '',
				keyword: '',
				cachekeyword: '',
				showsugflag: false,
				sugdelaytimer:'',
				sugstaytimer:'',
				sugwordsList:[],
				showhistroyflag: false,
				ishistoryaction: false,
				keyhistory: [],
				hotwords: [],
				pageNum: 1,
				pageSize: 10,
				totalResultCount: '',
				resultDataList: [],
				resultHitList: [],
				totalColumnCount: 0,
				resultColumnList: [],
				zcjdPanelVisible: false,
				zcjdpageNum: 1,
				zcjdtotalResultCount: 0,
				zcjdresultDataList: [],
				relateDataList: [],
				datePanelVisible: false,
				dateType:0,
				dateTypeText:'时间不限',
				searchdate:'',
				dateStr:'',
				isShowAISearch:false,
			}
		},
		created:function(){
			this.userinfo=this.$cookies.get('userinfo');
		},
		mounted: function() {
			this.gethotwordfnc();
			this.searchClick();
			this.getAIShowfnc();
		},
		watch: {
			$route(to, from) {
				if (to.params.searchword != from.params.searchword) {
					this.searchClick();
				}
			}
		},
		methods: {
			authcheck:function(){
				// debugger
				// this.hasPower=false;
				// if(!this.$cookies.get('userauth')){
				// 	this.hasPower=true;
				// }
				// else{
				// 	if(this.$cookies.get('userauth')=='1921f9e1416473a1d0f15d328e837115'){
				// 		this.hasPower=true;
				// 	}
				// 	if(this.$cookies.get('userauth').split(',').length>=5){
				// 		this.hasPower=true;
				// 	}
				// }
			},
			getAIShowfnc: function() {
				let _this = this;
				this.$httpai({
						method: 'get',
						url: 'authvipuser',
						responseType: 'json',
						params: {
							
						},
					})
					.then(function(response) {
						// debugger
						if(response.data.isvip){
							
							_this.isShowAISearch = true;
							
						}
					})
					.catch(function(error) {
						console.log(error);
					});
			},
			jumppush:function(to){
				this.authcheck();
				if(!this.hasPower){
					alert('您未购买此栏目!');
					return false;
				}
				else{
					var a = document.createElement('a');
					a.setAttribute('href', to);
					a.setAttribute('style', 'display:none');  
					a.setAttribute('target', '_blank');  
					document.body.appendChild(a);
					a.click();
					a.parentNode.removeChild(a); 
				}
			},
			clearword: function() {
				this.keyword = '';
				this.cachekeyword='';
			},
			showsug: function() {
				// debugger
				if (this.keyword) {
					if(this.cachekeyword!=this.keyword){
						// this.sugwordsList=[];
						// clearTimeout(this.sugdelaytimer)
						// let _timerthis=this;
						// this.sugdelaytimer = setTimeout(function (){
						    // _timerthis.getsugfnc();
								// _timerthis.showsugflag = true;
						// }, 100);
						// this.showsugflag = false;
						this.getsugfnc();
					}
					this.showsugflag = true;
					this.showhistroyflag = false;
				} else {
					this.keyhistory = this.$cookies.get('keyhistory') ? this.$cookies.get('keyhistory').split(',') : [];
					this.cachekeyword='';
					this.showsugflag = false;
					this.showhistroyflag = true;
				}
			},
			hidesug: function() {
				this.showsugflag = false;
				this.showhistroyflag = false;
			},
			searchHistory: function() {
				var temphistorylist = this.$cookies.get('keyhistory') ? this.$cookies.get('keyhistory').split(',') : [];
				if (temphistorylist.indexOf(this.keyword) < 0) {
					if (temphistorylist.length > 4) {
						temphistorylist.pop();
					}
					temphistorylist.unshift(this.keyword);
					this.$cookies.set('keyhistory', temphistorylist.toString(),'30d');
				}
			},
			removehistory: function(key) {
				var temphistorylist = this.$cookies.get('keyhistory') ? this.$cookies.get('keyhistory').split(',') : [];
				if (temphistorylist.indexOf(key) > -1) {
					temphistorylist.splice(temphistorylist.indexOf(key), 1);
					this.keyhistory = temphistorylist;
					this.$cookies.set('keyhistory', temphistorylist.toString(),'30d');
				}
			},
			removehistoryall: function() {
				this.keyhistory = '';
				this.$cookies.remove('keyhistory');
			},
			selhistory: function(key) {
				this.keyword = key;
				this.searchJump();
			},
			getsugfnc: function() {
				if (this.keyword) {
					let _this = this;
					this.cachekeyword=this.keyword;
					this.$http({
							method: 'get',
							url: 'SearchInfo/SugHotWordListInfo',
							responseType: 'json',
							params: {
								sugKey: this.keyword,
							},
						})
						.then(function(response) {
							// debugger;
							_this.sugwordsList = response.data.data.data;
							clearTimeout(_this.sugstaytimer);
							_this.sugstaytimer = setTimeout(function (){
								if(_this.showsugflag&&_this.sugwordsList.length>0){
									_this.$track([
										['pagetype','sug提示'],
										['searchkeyword',_this.sugwordsList.join(' ')]
									]);
								}
							}, 2000);
							if(_this.sugwordsList.length<1){
								_this.showsugflag = false;
							}
						})
						.catch(function(error) {
							console.log(error);
						});
				}
			},
			gethotwordfnc: function() {
				let _this = this;
				this.$http({
						method: 'get',
						url: 'SearchInfo/SearchWordsListInfo',
						responseType: 'json',
						params: {
						},
					})
					.then(function(response) {
						_this.hotwords = response.data.data.data;
					})
					.catch(function(error) {
						console.log(error);
					});
			},
			showDatePanel:function(){
				this.datePanelVisible=true;
				let _this = this;
				var listenerfunc=function(e){
					if(!document.getElementById('datePanelDiv').contains(e.target)){
						_this.datePanelVisible=false;
						document.removeEventListener('click',listenerfunc);
					}
				}
				document.addEventListener('click',listenerfunc)
			},
			dateClick(value,name){
				// debugger
				if(value==4&&!this.dateStr){
					return false;
				}
				this.dateType=value;
				this.dateTypeText=name;
				this.datePanelVisible=false;
				this.pageNum = 1;
				this.$track([
					['pagetype','搜索时间筛选'],
					['reqtype','2'],
					['column',this.searchColum],
					['searchkeyword',this.searchword]
				]);
				this.searchfnc();
			},
			datepickerClick(){

			},
			aisearchJump:function(){
				if (this.keyword) {
					let to = window.SITE_CONFIG['aiSearchUrl']+encodeURIComponent(this.keyword);
					var a = document.createElement('a');
					a.setAttribute('href', to);
					a.setAttribute('style', 'display:none');  
					a.setAttribute('target', '_blank');  
					document.body.appendChild(a);
					a.click();
					a.parentNode.removeChild(a); 
				}
			},
			searchJump: function() {
				if (this.keyword) {
					if (this.keyword == this.searchword) {
						this.searchClick();
					} else {
						this.$router.push('/search' + (this.keyword ? ('/' + encodeURIComponent(this.keyword)) : ''));
					}

				}
			},
			searchClick: function() {
				// console.log(this.$route.params.searchword);
				// console.log(decodeURIComponent(this.$route.params.searchword));
				this.searchword = this.$route.params.searchword;
				this.keyword = this.searchword;
				document.title='检索中心-中经专网';
				this.$track([
					['pagetype','搜索'],
					['searchkeyword',this.searchword]
				]);
				if (this.keyword) {
					document.title=this.keyword+'-检索中心';
					this.searchColum = '';
					this.pageNum = 1;
					this.pageSize = 10;
					this.dateType=0;
					this.dateTypeText='时间不限';
					this.searchHistory();
					this.searchfnc();
					// this.searchRelate();
				}
			},
			searchfnc: function() {
				// debugger
				let _this = this;
				_this.loadingMask = true;
				// this.resultDataList = {};
				// this.totalResultCount = 0;
				this.$http({
						method: 'get',
						url: 'SearchInfo/searchListInfo',
						responseType: 'json',
						params: {
							lstkey: this.keyword,
							iPageNum: this.pageNum,
							iPageSize: this.pageSize,
							ColID: this.searchColum,
							dateType: this.dateType,
							dateStr: (this.dateType==4&&this.dateStr&&this.dateStr.length>1)?(this.dateStr[0]+'#'+this.dateStr[1]):'',
						},
					})
					.then(function(response) {
						if(response.data.data){
							_this.resultDataList = response.data.data.data.tempResult.artLst;
							_this.resultHitList = response.data.data.data.tempResult.dataList;
							_this.totalResultCount = response.data.data.data.tempResult.totalCount;
							if(_this.totalResultCount==0){
								_this.$track([
									['pagetype','搜索为空'],
									['searchkeyword',_this.searchword]
								]);
							}
							if ((!_this.searchColum)&&(_this.pageNum==1)) {
								_this.totalColumnCount = _this.totalResultCount;
								_this.resultColumnList = response.data.data.data.tempResult.columnCount;
							}
						}
						else{
							
						}
						_this.loadingMask = false;
					})
					.catch(function(error) {
						_this.loadingMask = false;
						console.log(error);
					});;
			},
			changePageSize: function(pagesize) {
				this.pageSize = pagesize;
				this.searchfnc();
			},
			changeSearchPage: function(page) {
				// console.log(page);
				this.pageNum = page;
				this.searchfnc();
				document.body.scrollTop = 0;
				document.documentElement.scrollTop = 0;
			},
			searchColumChange: function(index, indexPath) {
				// console.log(index);
				this.searchColum = index;
				this.$track([
					['pagetype','搜索子分类'],
					['reqtype','2'],
					['column',this.searchColum],
					['searchkeyword',this.searchword]
				]);
				this.pageNum = 1;
				this.pageSize = 10;
				this.searchfnc();
			},
			showZCJD: function(artid) {
				this.zcjdsearchfnc(artid);
				this.zcjdPanelVisible = true;
				document.getElementsByTagName('body')[0].style.overflowY='hidden';
			},
			hideZCJD: function(artid) {
				this.zcjdPanelVisible = false;
				document.getElementsByTagName('body')[0].style.overflowY='auto';
			},
			zcjdsearchfnc: function(artid) {
				let _this = this;
				let _artid = artid;
				_this.loadingMaskZcjd=true;
				// this.resultDataList = {};
				// this.totalResultCount = 0;
				this.$http({
						method: 'get',
						url: 'SearchInfo/artRelListInfo',
						responseType: 'json',
						params: {
							artID: artid,
							iPageNum: this.zcjdpageNum,
							iPageSize: 10,
						},
					})
					.then(function(response) {
						_this.zcjdresultDataList = response.data.data.data.tempResult.artLst;
						_this.zcjdtotalResultCount = response.data.data.data.tempResult.totalCount;
						_this.$track([
							['pagetype','政策解读'],
							['reqtype','1'],
							['pageid',_artid]
						]);
						_this.loadingMaskZcjd=false;
					})
					.catch(function(error) {
						console.log(error);
						_this.loadingMaskZcjd=false;
					});
			},
			zcjdchangeSearchPage: function(page) {
				// console.log(page);
				this.zcjdpageNum = page;
				this.zcjdsearchfnc();
			},
			searchRelate: function() {
				let _this = this;
				this.$http({
						method: 'get',
						url: 'SearchInfo/RelateWordListInfo',
						responseType: 'json',
						params: {
							lstkey: this.keyword,
						},
					})
					.then(function(response) {
						_this.relateDataList = response.data.data.data.Similarkeyword ? response.data.data.data
							.Similarkeyword.split('|') : [];
					})
					.catch(function(error) {
						console.log(error);
					});
			},
			showfankui:function(){
				this.$emit('showzixunjianyifromsearch');
			}
		}
	}
</script>

<style>

	.Search_wrapper .el-menu {
		display: flex;
		width: 100%;
		margin-bottom: 24px;
	}

	.Search_wrapper .el-menu-item {
		display: block;
		width: 100%;
		text-align: center;
		font-size: 16px;
		font-weight: 600;
	}
	
	.Search_wrapper .el-menu--horizontal>.el-menu-item{
		border-bottom: 0px;
	}
	.Search_wrapper .el-menu--horizontal>.el-menu-item.is-active{
		border-bottom: 0px;
	}
	
	.Search_wrapper .el-menu-item.is-active:after {
		content: '';
		margin: 0px 0px -1px -8px;
		position: absolute;
		left: 50%;
		top: auto;
		bottom: 0;
		right: 50%;
		height: 2px;
		width: 16px;
		background-color: #bd1a2d;
	}


	.rel_search tit {
		margin-top: 16px;
	}

	.Search_wrapper .el-dialog {
		margin-top: 0px !important;
		position: absolute;
		height: 100%;
		right: 0px;
	}

	.Search_wrapper .el-dialog__header {
		background: #fde5e5;
	}
	
	.Search_wrapper .thematic_list .list4 .li2 a{
		white-space: normal; 
	}
	
	.Search_wrapper .policy_list li .tit a:before{
		margin-left: -25px;
	}
	.Search_wrapper .policy_list li .tit a{
		padding-left: 25px;
	}
</style>
